import { render } from "./NotificationList.vue?vue&type=template&id=692585f3"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"
script.render = render

export default script